module.exports = __webpack_public_path__ + "static/media/trash.494275d9.svg";